import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input } from '../../../Elements';
import styles from './TermsBuilder.scss';

const LateFees = ({ contractVariables, textFieldChange }) => (
  <div>
    <h3>How many days after an invoice is due will you charge a late fee?</h3>
    <Input
      className={styles.inlineField}
      name='paymentGracePeriod'
      type='number'
      inline
      required
      validationError='Required'
      value={contractVariables.paymentGracePeriod}
      onChange={textFieldChange}
    />
    <div className={styles.inlineFieldLabel}>days</div>
    <h3>What percentage interest will you charge, per month, for late payments?</h3>
    <Input
      className={styles.inlineField}
      name='interest'
      type='number'
      inline
      required
      validationError='Required'
      value={contractVariables.interest}
      onChange={textFieldChange}
    />
    <div className={styles.inlineFieldLabel}>percent</div>
  </div>
);

LateFees.propTypes = {
  contractVariables: PropTypes.object.isRequired,
  textFieldChange: PropTypes.func.isRequired
};

export default LateFees;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/TermsBuilder/LateFees.js